// extracted by mini-css-extract-plugin
module.exports = {"modal":"LogOfflineActivities_modal__2RWJ4"};